import { onMounted, onBeforeUnmount } from 'vue'

export interface ShortcutHandlers {
  onNavigate?: (routeName: string) => void
  onToggleTheme?: () => void
  onOpenGuide?: () => void
}

const PREFIX_TIMEOUT_MS = 1500

const G_MAP: Record<string, string> = {
  d: 'overview',
  p: 'pursuit',
  f: 'fleet',
  h: 'history',
  s: 'stats',
}

function isEditable(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false
  const tag = target.tagName
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true
  if (target.isContentEditable) return true
  return false
}

export function useKeyboardShortcuts(handlers: ShortcutHandlers) {
  let prefixActive = false
  let prefixTimer: ReturnType<typeof setTimeout> | null = null

  function clearPrefix() {
    prefixActive = false
    if (prefixTimer !== null) {
      clearTimeout(prefixTimer)
      prefixTimer = null
    }
  }

  function onKeydown(ev: KeyboardEvent) {
    if (isEditable(ev.target)) return
    if (ev.ctrlKey || ev.metaKey || ev.altKey) return

    const k = ev.key

    if (prefixActive) {
      const route = G_MAP[k]
      if (route && handlers.onNavigate) {
        handlers.onNavigate(route)
      }
      clearPrefix()
      return
    }

    if (k === 'g') {
      prefixActive = true
      prefixTimer = setTimeout(clearPrefix, PREFIX_TIMEOUT_MS)
      return
    }

    if (k === '?' && handlers.onOpenGuide) {
      handlers.onOpenGuide()
      return
    }

    if (k === 't' && handlers.onToggleTheme) {
      handlers.onToggleTheme()
      return
    }
  }

  onMounted(() => {
    document.addEventListener('keydown', onKeydown)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('keydown', onKeydown)
    clearPrefix()
  })
}
